// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { Navigate } from 'react-router-dom';
import { type ProductVariant } from '../context/VariantContext';
import { useProductVariant } from '../context/variant';

interface Props {
  required: ProductVariant;
  children: JSX.Element;
}

/**
 * VariantRoute guards a route by product variant.
 * If the current deployment's variant does not match `required`,
 * the user is redirected to /dashboard.
 */
export function VariantRoute({ required, children }: Props) {
  const variant = useProductVariant();
  if (variant !== required) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
